import './Header.less';
import * as React from 'react';
import classnames from 'classnames';

interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  prefixCls?: string;
  className?: string;
  displayType?: 'flex';
  align?: 'top' | 'middle' | 'bottom';
  justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between';
}

const Header: React.SFC<HeaderProps> = (props) => {
  const {
    prefixCls = 'mpc-card-page-header', children, className, displayType,
    justify, align, ...others
  } = props;
  const classes = classnames({
    [`${prefixCls}`]: true,
    [`${prefixCls}-${displayType}`]: true,
    [`${prefixCls}-${displayType}-${justify}`]: displayType && justify,
    [`${prefixCls}-${displayType}-${align}`]: displayType && align,
  }, className);
  return (
    <div {...others} className={classes}>
      {children}
    </div>
  );
};

export default Header;
